import * as RadixPortal from '@radix-ui/react-portal'
import { useAction } from '@reatom/npm-react'
import styled from 'styled-components'

import { Button, Typography } from '@blade/ui-kit'
import { useTranslation } from '@root/shared/localization'
import { ChevronLeftIcon, Separator } from '@root/shared/ui-kit'

import { closeScanQrAction } from '../atoms'

import { ScanFocusBox } from './scan-focus-box'

import type { ClassNameProps } from '@root/shared/react'

type ScanScreenProps = {} & ClassNameProps

export const ScanScreen: React.FC<ScanScreenProps> = ({ className }) => {
  const { t } = useTranslation()
  const closeScanQr = useAction(closeScanQrAction)

  return (
    <RadixPortal.Root>
      <Root className={className}>
        <Header>
          <HeaderContent>
            <Button
              onClick={() => {
                closeScanQr()
              }}
              variant="ghost"
              iconLeft={<ChevronLeftIcon />}
            />
            <Title>{t('scan.scan-qr-code')}</Title>
          </HeaderContent>
          <Separator />
        </Header>
        <ScanFocusBox />
        <Description>{t('scan.scan-qr-code-description')}</Description>
      </Root>
    </RadixPortal.Root>
  )
}

const Root = styled.div`
  padding-top: var(--safe-top);

  position: fixed;
  inset: 0;
  display: grid;
  align-content: start;
  z-index: 10px;
`

const Header = styled.div`
  padding-inline: 8px;
  margin-top: 10px;
  position: relative;
  z-index: 1;

  color: var(--text-12);
`

const HeaderContent = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: 40px 1fr 40px;
  justify-items: center;
  gap: 10px;
  align-items: center;
  margin-bottom: 4px;
`

const Title = styled(Typography).attrs({
  variant: 'body2-medium',
  component: 'div',
})`
  color: var(--White, #fff);
`

const Description = styled(Typography).attrs({
  variant: 'body5-medium',
  component: 'div',
})`
  color: var(--textA-10);
  text-align: center;
  z-index: 1;
  margin-top: 14px;
`
